import gql from 'graphql-tag';

// eslint-disable-next-line import/prefer-default-export
export const getProxyNotification = gql`
  query GetProxyNotificationV2($userID: String!) {
    getProxyNotificationV2(userID: $userID) {
      userID
      relation
      direction
      relatedUserID
      relatedUsername
      lastUpdatedTime
      type
    }
  }
`;

export const getTeamProxy = /* GraphQL */ gql`
  query GetTeamProxyV2($userID: String!, $directReportUserIds: [String]!) {
    getTeamProxyV2(userID: $userID, directReportUserIds: $directReportUserIds) {
      success
      messageCode
      proxyRelations {
        userID
        proxyCoachees
        proxyCoaches
      }
    }
  }
`;
